import * as employeesService from "@/services/employeesService";
import { Invitation } from "@/services/employees/invitation/fetchInvitations";
import { supabase } from "@/integrations/supabase/client";
import { useAuthStore } from "@/store/authStore";

// Invitation operations
export const invitationOperations = {
  fetchInvitations: async (storeId: string | null) => {
    try {
      // Get the current user ID for filtering invitations they created
      const userId = useAuthStore.getState().user?.id;

      // If we have a specific store ID, use that for filtering
      if (storeId) {
        const invitations = await employeesService.fetchInvitations(storeId);
        return invitations;
      }
      // Otherwise, try to fetch invitations created by the current user
      else if (userId) {
        // Direct query to get invitations created by the current user
        const { data, error } = await supabase
          .from("employee_invitations")
          .select("*")
          .eq("invited_by_user_id", userId)
          .eq("accepted", false);

        if (error) {
          console.error("Error fetching user invitations:", error);
          return [];
        }

        return data || [];
      }
      // Fallback to fetching all invitations (for admin)
      else {
        const invitations = await employeesService.fetchInvitations(undefined);
        return invitations;
      }
    } catch (error) {
      console.error("Failed to fetch invitations:", error);
      throw error;
    }
  },

  revokeInvitation: async (invitationId: string) => {
    try {
      const success = await employeesService.revokeInvitation(invitationId);
      return success;
    } catch (error) {
      console.error("Failed to revoke invitation:", error);
      throw error;
    }
  },
};
